import { HomeOutlined, WarningOutlined, ApiOutlined, BookOutlined } from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useAlarmGroupContext } from '_/contexts/AlarmGroupContext';
import { useFlowContext } from '_/contexts/FlowContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const homeIcon = <HomeOutlined />;
const warningIcon = <WarningOutlined />;
const apiIcon = <ApiOutlined />;
const bookIcon = <BookOutlined />;

export function useAlarmGroupSidebarItems(): SidebarItem[] {
  const { selectedOrgSlug } = useOrganization();
  const { selectedProjectSlug } = useProject();
  const { flowSlug } = useFlowContext();
  const { alarmGroupId } = useAlarmGroupContext();

  return useMemo(
    () => [
      {
        icon: homeIcon,
        text: 'Alarm group Home',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/alarmgroups/${alarmGroupId}/home`,
      },
      {
        icon: warningIcon,
        text: 'Alarms',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/alarmgroups/${alarmGroupId}/alarms`,
      },
      {
        icon: apiIcon,
        text: 'Integrations',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/alarmgroups/${alarmGroupId}/integrations`,
      },
      {
        icon: bookIcon,
        text: 'Runbook',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/alarmgroups/${alarmGroupId}/runbook`,
      },
    ],
    [selectedOrgSlug, selectedProjectSlug, flowSlug, alarmGroupId],
  );
}
